/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CoverLetter } from '../models';
// @ts-ignore
import type { CoverLetterRunResponse } from '../models';
// @ts-ignore
import type { CreateCoverLetterBody } from '../models';
// @ts-ignore
import type { DownloadCoverLetterPdfBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllCoverLettersResponse } from '../models';
// @ts-ignore
import type { GetCoverLetterSourceResponse } from '../models';
// @ts-ignore
import type { RefineCoverLetterBody } from '../models';
// @ts-ignore
import type { UpdateCoverLetterBody } from '../models';
/**
 * CoverLetterApiApi - axios parameter creator
 */
export const CoverLetterApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} coverLetterId 
         * @param {DownloadCoverLetterPdfBody} downloadCoverLetterPdfBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiDownloadCoverLetterPdf: async (coverLetterId: string, downloadCoverLetterPdfBody: DownloadCoverLetterPdfBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverLetterId' is not null or undefined
            assertParamExists('coverLetterApiDownloadCoverLetterPdf', 'coverLetterId', coverLetterId)
            // verify required parameter 'downloadCoverLetterPdfBody' is not null or undefined
            assertParamExists('coverLetterApiDownloadCoverLetterPdf', 'downloadCoverLetterPdfBody', downloadCoverLetterPdfBody)
            const localVarPath = `/cover-letter/{cover_letter_id}/pdf`
                .replace('{cover_letter_id}', encodeURIComponent(String(coverLetterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadCoverLetterPdfBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {CreateCoverLetterBody} createCoverLetterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGenerateCoverLetter: async (jobId: string, createCoverLetterBody: CreateCoverLetterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('coverLetterApiGenerateCoverLetter', 'jobId', jobId)
            // verify required parameter 'createCoverLetterBody' is not null or undefined
            assertParamExists('coverLetterApiGenerateCoverLetter', 'createCoverLetterBody', createCoverLetterBody)
            const localVarPath = `/job/{job_id}/cover-letter`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCoverLetterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} coverLetterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGetCoverLetter: async (coverLetterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverLetterId' is not null or undefined
            assertParamExists('coverLetterApiGetCoverLetter', 'coverLetterId', coverLetterId)
            const localVarPath = `/cover-letter/{cover_letter_id}`
                .replace('{cover_letter_id}', encodeURIComponent(String(coverLetterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string | null} [userResumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGetCoverLetterSource: async (jobId: string, userResumeId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('coverLetterApiGetCoverLetterSource', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/cover-letter-source`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userResumeId !== undefined) {
                localVarQueryParameter['user_resume_id'] = userResumeId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGetCoverLetters: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('coverLetterApiGetCoverLetters', 'jobId', jobId)
            const localVarPath = `/job/{job_id}/cover-letters`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} coverLetterId 
         * @param {RefineCoverLetterBody} refineCoverLetterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiRefineCoverLetter: async (coverLetterId: string, refineCoverLetterBody: RefineCoverLetterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverLetterId' is not null or undefined
            assertParamExists('coverLetterApiRefineCoverLetter', 'coverLetterId', coverLetterId)
            // verify required parameter 'refineCoverLetterBody' is not null or undefined
            assertParamExists('coverLetterApiRefineCoverLetter', 'refineCoverLetterBody', refineCoverLetterBody)
            const localVarPath = `/cover-letter/{cover_letter_id}/refine`
                .replace('{cover_letter_id}', encodeURIComponent(String(coverLetterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineCoverLetterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} coverLetterId 
         * @param {UpdateCoverLetterBody} updateCoverLetterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiUpdateCoverLetter: async (coverLetterId: string, updateCoverLetterBody: UpdateCoverLetterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverLetterId' is not null or undefined
            assertParamExists('coverLetterApiUpdateCoverLetter', 'coverLetterId', coverLetterId)
            // verify required parameter 'updateCoverLetterBody' is not null or undefined
            assertParamExists('coverLetterApiUpdateCoverLetter', 'updateCoverLetterBody', updateCoverLetterBody)
            const localVarPath = `/cover-letter/{cover_letter_id}`
                .replace('{cover_letter_id}', encodeURIComponent(String(coverLetterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCoverLetterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CoverLetterApiApi - functional programming interface
 */
export const CoverLetterApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CoverLetterApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} coverLetterId 
         * @param {DownloadCoverLetterPdfBody} downloadCoverLetterPdfBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverLetterApiDownloadCoverLetterPdf(coverLetterId: string, downloadCoverLetterPdfBody: DownloadCoverLetterPdfBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverLetterApiDownloadCoverLetterPdf(coverLetterId, downloadCoverLetterPdfBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverLetterApiApi.coverLetterApiDownloadCoverLetterPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {CreateCoverLetterBody} createCoverLetterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverLetterApiGenerateCoverLetter(jobId: string, createCoverLetterBody: CreateCoverLetterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverLetterRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverLetterApiGenerateCoverLetter(jobId, createCoverLetterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverLetterApiApi.coverLetterApiGenerateCoverLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} coverLetterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverLetterApiGetCoverLetter(coverLetterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverLetter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverLetterApiGetCoverLetter(coverLetterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverLetterApiApi.coverLetterApiGetCoverLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string | null} [userResumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverLetterApiGetCoverLetterSource(jobId: string, userResumeId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCoverLetterSourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverLetterApiGetCoverLetterSource(jobId, userResumeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverLetterApiApi.coverLetterApiGetCoverLetterSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverLetterApiGetCoverLetters(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllCoverLettersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverLetterApiGetCoverLetters(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverLetterApiApi.coverLetterApiGetCoverLetters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} coverLetterId 
         * @param {RefineCoverLetterBody} refineCoverLetterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverLetterApiRefineCoverLetter(coverLetterId: string, refineCoverLetterBody: RefineCoverLetterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverLetterRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverLetterApiRefineCoverLetter(coverLetterId, refineCoverLetterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverLetterApiApi.coverLetterApiRefineCoverLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} coverLetterId 
         * @param {UpdateCoverLetterBody} updateCoverLetterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverLetterApiUpdateCoverLetter(coverLetterId: string, updateCoverLetterBody: UpdateCoverLetterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoverLetter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverLetterApiUpdateCoverLetter(coverLetterId, updateCoverLetterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoverLetterApiApi.coverLetterApiUpdateCoverLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CoverLetterApiApi - factory interface
 */
export const CoverLetterApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CoverLetterApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CoverLetterApiApiCoverLetterApiDownloadCoverLetterPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiDownloadCoverLetterPdf(requestParameters: CoverLetterApiApiCoverLetterApiDownloadCoverLetterPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.coverLetterApiDownloadCoverLetterPdf(requestParameters.coverLetterId, requestParameters.downloadCoverLetterPdfBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CoverLetterApiApiCoverLetterApiGenerateCoverLetterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGenerateCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiGenerateCoverLetterRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverLetterRunResponse> {
            return localVarFp.coverLetterApiGenerateCoverLetter(requestParameters.jobId, requestParameters.createCoverLetterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CoverLetterApiApiCoverLetterApiGetCoverLetterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGetCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiGetCoverLetterRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverLetter> {
            return localVarFp.coverLetterApiGetCoverLetter(requestParameters.coverLetterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CoverLetterApiApiCoverLetterApiGetCoverLetterSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGetCoverLetterSource(requestParameters: CoverLetterApiApiCoverLetterApiGetCoverLetterSourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCoverLetterSourceResponse> {
            return localVarFp.coverLetterApiGetCoverLetterSource(requestParameters.jobId, requestParameters.userResumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CoverLetterApiApiCoverLetterApiGetCoverLettersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiGetCoverLetters(requestParameters: CoverLetterApiApiCoverLetterApiGetCoverLettersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllCoverLettersResponse> {
            return localVarFp.coverLetterApiGetCoverLetters(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CoverLetterApiApiCoverLetterApiRefineCoverLetterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiRefineCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiRefineCoverLetterRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverLetterRunResponse> {
            return localVarFp.coverLetterApiRefineCoverLetter(requestParameters.coverLetterId, requestParameters.refineCoverLetterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CoverLetterApiApiCoverLetterApiUpdateCoverLetterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverLetterApiUpdateCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiUpdateCoverLetterRequest, options?: RawAxiosRequestConfig): AxiosPromise<CoverLetter> {
            return localVarFp.coverLetterApiUpdateCoverLetter(requestParameters.coverLetterId, requestParameters.updateCoverLetterBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for coverLetterApiDownloadCoverLetterPdf operation in CoverLetterApiApi.
 */
export interface CoverLetterApiApiCoverLetterApiDownloadCoverLetterPdfRequest {
    readonly coverLetterId: string

    readonly downloadCoverLetterPdfBody: DownloadCoverLetterPdfBody
}

/**
 * Request parameters for coverLetterApiGenerateCoverLetter operation in CoverLetterApiApi.
 */
export interface CoverLetterApiApiCoverLetterApiGenerateCoverLetterRequest {
    readonly jobId: string

    readonly createCoverLetterBody: CreateCoverLetterBody
}

/**
 * Request parameters for coverLetterApiGetCoverLetter operation in CoverLetterApiApi.
 */
export interface CoverLetterApiApiCoverLetterApiGetCoverLetterRequest {
    readonly coverLetterId: string
}

/**
 * Request parameters for coverLetterApiGetCoverLetterSource operation in CoverLetterApiApi.
 */
export interface CoverLetterApiApiCoverLetterApiGetCoverLetterSourceRequest {
    readonly jobId: string

    readonly userResumeId?: string | null
}

/**
 * Request parameters for coverLetterApiGetCoverLetters operation in CoverLetterApiApi.
 */
export interface CoverLetterApiApiCoverLetterApiGetCoverLettersRequest {
    readonly jobId: string
}

/**
 * Request parameters for coverLetterApiRefineCoverLetter operation in CoverLetterApiApi.
 */
export interface CoverLetterApiApiCoverLetterApiRefineCoverLetterRequest {
    readonly coverLetterId: string

    readonly refineCoverLetterBody: RefineCoverLetterBody
}

/**
 * Request parameters for coverLetterApiUpdateCoverLetter operation in CoverLetterApiApi.
 */
export interface CoverLetterApiApiCoverLetterApiUpdateCoverLetterRequest {
    readonly coverLetterId: string

    readonly updateCoverLetterBody: UpdateCoverLetterBody
}

/**
 * CoverLetterApiApi - object-oriented interface
 */
export class CoverLetterApiApi extends BaseAPI {
    /**
     * 
     * @param {CoverLetterApiApiCoverLetterApiDownloadCoverLetterPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverLetterApiDownloadCoverLetterPdf(requestParameters: CoverLetterApiApiCoverLetterApiDownloadCoverLetterPdfRequest, options?: RawAxiosRequestConfig) {
        return CoverLetterApiApiFp(this.configuration).coverLetterApiDownloadCoverLetterPdf(requestParameters.coverLetterId, requestParameters.downloadCoverLetterPdfBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CoverLetterApiApiCoverLetterApiGenerateCoverLetterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverLetterApiGenerateCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiGenerateCoverLetterRequest, options?: RawAxiosRequestConfig) {
        return CoverLetterApiApiFp(this.configuration).coverLetterApiGenerateCoverLetter(requestParameters.jobId, requestParameters.createCoverLetterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CoverLetterApiApiCoverLetterApiGetCoverLetterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverLetterApiGetCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiGetCoverLetterRequest, options?: RawAxiosRequestConfig) {
        return CoverLetterApiApiFp(this.configuration).coverLetterApiGetCoverLetter(requestParameters.coverLetterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CoverLetterApiApiCoverLetterApiGetCoverLetterSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverLetterApiGetCoverLetterSource(requestParameters: CoverLetterApiApiCoverLetterApiGetCoverLetterSourceRequest, options?: RawAxiosRequestConfig) {
        return CoverLetterApiApiFp(this.configuration).coverLetterApiGetCoverLetterSource(requestParameters.jobId, requestParameters.userResumeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CoverLetterApiApiCoverLetterApiGetCoverLettersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverLetterApiGetCoverLetters(requestParameters: CoverLetterApiApiCoverLetterApiGetCoverLettersRequest, options?: RawAxiosRequestConfig) {
        return CoverLetterApiApiFp(this.configuration).coverLetterApiGetCoverLetters(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CoverLetterApiApiCoverLetterApiRefineCoverLetterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverLetterApiRefineCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiRefineCoverLetterRequest, options?: RawAxiosRequestConfig) {
        return CoverLetterApiApiFp(this.configuration).coverLetterApiRefineCoverLetter(requestParameters.coverLetterId, requestParameters.refineCoverLetterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CoverLetterApiApiCoverLetterApiUpdateCoverLetterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverLetterApiUpdateCoverLetter(requestParameters: CoverLetterApiApiCoverLetterApiUpdateCoverLetterRequest, options?: RawAxiosRequestConfig) {
        return CoverLetterApiApiFp(this.configuration).coverLetterApiUpdateCoverLetter(requestParameters.coverLetterId, requestParameters.updateCoverLetterBody, options).then((request) => request(this.axios, this.basePath));
    }
}

